import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreText?: string;
  moreTo?: string;
}

export default function SectionHeading({ icon, title, subtitle, moreText, moreTo }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="flex w-8 h-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className={`${icon} text-lg`} />
          </span>
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && moreText && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1 text-sm font-semibold text-primary-600 whitespace-nowrap transition-colors hover:text-primary-700"
        >
          {moreText}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}